import { render, staticRenderFns } from "./study-participant-edcForm-reskin.vue?vue&type=template&id=a59661c8&scoped=true&"
import script from "./study-participant-edcForm-reskin.vue?vue&type=script&lang=js&"
export * from "./study-participant-edcForm-reskin.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-edcForm-reskin.vue?vue&type=style&index=0&id=a59661c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59661c8",
  null
  
)

component.options.__file = "study-participant-edcForm-reskin.vue"
export default component.exports